import React from 'react';
import { Dialog, DialogContent } from '../../../components/ui/dialog';
import { Drawer, DrawerContent } from '../../../components/ui/drawer';
import { Button } from '../../../components/ui/button'; // Assuming Button is used for close
import { X } from 'lucide-react'; // Assuming X icon for close button

export function PerformanceModalSkeleton({ isOpen, onClose, isDesktop }) {
  const CustomCloseButtonSkeleton = () => (
    <Button
      variant="outline"
      size="icon"
      className="absolute left-1/2 -translate-x-1/2 -top-20 h-10 w-10 rounded-full bg-[var(--q3-surface-dim)] animate-pulse z-50 flex items-center justify-center"
      aria-label="Close"
      disabled // Disable interaction during skeleton state
    >
      <X className="h-8 w-8 text-[var(--q3-neutral-default)]" />
    </Button>
  );

  const ModalContentSkeleton = () => (
    <div className="border-1 rounded-2xl pb-5 animate-pulse">
      {/* Skeleton for Tabs */}
      <div className="flex justify-around p-2 rounded-t-2xl bg-[var(--q3-surface-dim)] mb-4 h-12">
        <div className="h-8 w-24 bg-[var(--q3-surface-default)] rounded-full"></div>
        <div className="h-8 w-24 bg-[var(--q3-surface-default)] rounded-full"></div>
        <div className="h-8 w-24 bg-[var(--q3-surface-default)] rounded-full"></div>
        <div className="h-8 w-24 bg-[var(--q3-surface-default)] rounded-full"></div>
      </div>

      {/* Skeleton for Table Header */}
      <table className="w-full min-w-[500px]">
        <thead>
          <tr style={{ backgroundColor: 'var(--q3-surface-dim)' }}>
            <th className="text-left p-5 font-medium border-1 rounded-tl-2xl">
              <div className="h-4 w-20 bg-[var(--q3-surface-default)] rounded-md"></div>
            </th>
            <th className="text-center p-5 font-medium border-1">
              <div className="h-4 w-24 bg-[var(--q3-surface-default)] rounded-md mx-auto"></div>
            </th>
            <th className="text-center p-5 font-medium border-1">
              <div className="h-4 w-32 bg-[var(--q3-surface-default)] rounded-md mx-auto"></div>
            </th>
            <th className="text-center p-5 font-medium border-1 rounded-tr-2xl">
              <div className="h-4 w-24 bg-[var(--q3-surface-default)] rounded-md mx-auto"></div>
            </th>
          </tr>
        </thead>
        <tbody>
          {/* Skeleton for Table Rows */}
          {Array.from({ length: 4 }).map((_, rowIndex) => (
            <tr key={rowIndex} className="h-20">
              <td className="p-5 flex items-center gap-3 border-b-1">
                <div className="h-5 w-5 bg-[var(--q3-surface-dimmer)] rounded-full"></div>
                <div className="h-4 w-24 bg-[var(--q3-surface-dim)] rounded-md"></div>
              </td>
              <td className="p-0 border-1">
                <div className="h-full flex flex-col justify-center items-center">
                  <div className="h-6 w-16 bg-[var(--q3-surface-dim)] rounded-md mb-1"></div>
                  <div className="h-4 w-12 bg-[var(--q3-surface-dim)] rounded-md"></div>
                </div>
              </td>
              <td className="p-0 border-1">
                <div className="h-full flex flex-col justify-center items-center">
                  <div className="h-6 w-16 bg-[var(--q3-surface-dim)] rounded-md mb-1"></div>
                  <div className="h-4 w-12 bg-[var(--q3-surface-dim)] rounded-md"></div>
                </div>
              </td>
              <td className={`p-0 border-1 ${rowIndex === 3 ? 'rounded-br-2xl' : ''}`}>
                <div className="h-full flex flex-col justify-center items-center">
                  <div className="h-6 w-16 bg-[var(--q3-surface-dim)] rounded-md mb-1"></div>
                  <div className="h-4 w-12 bg-[var(--q3-surface-dim)] rounded-md"></div>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );

  if (isDesktop) {
    return (
      <Dialog open={isOpen} onOpenChange={onClose}>
        <DialogContent
          showCloseButton={false}
          className="p-6 backdrop-blur-sm"
          style={{
            width: 'max-content',
            maxWidth: '95vw',
            minWidth: '700px',
          }}
        >
          <div className="relative h-full max-h-[80vh]">
            <CustomCloseButtonSkeleton />
            <div className="h-full overflow-y-auto">
              <h2 className="text-xl font-semibold text-center mb-6" style={{ color: 'var(--q3-neutral-default)' }}>
                <div className="h-7 w-64 bg-[var(--q3-surface-dim)] rounded-md mx-auto"></div>
              </h2>
              <ModalContentSkeleton />
            </div>
          </div>
        </DialogContent>
      </Dialog>
    );
  }

  return (
    <Drawer open={isOpen} onOpenChange={onClose}>
      <DrawerContent showCloseButton={false} className="max-h-[90vh] py-0 px-4">
        <div className="relative h-full">
          <CustomCloseButtonSkeleton />
          <div className="h-full overflow-y-auto pt-8">
            <h2 className="text-xl font-semibold text-center mb-6" style={{ color: 'var(--q3-neutral-default)' }}>
              <div className="h-7 w-64 bg-[var(--q3-surface-dim)] rounded-md mx-auto"></div>
            </h2>
            <ModalContentSkeleton />
          </div>
        </div>
      </DrawerContent>
    </Drawer>
  );
}
